
// Import Bootstrap Icons
import 'bootstrap-icons/font/bootstrap-icons.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import React from 'react';
import ReactDOM from 'react-dom/client';
import Root from './Root';
import { config, MISSING_CONFIG } from './config';
import { initAnalytics } from './analytics';

if (MISSING_CONFIG.length > 0) {
  console.error(`[config] Missing required environment variables: ${MISSING_CONFIG.join(', ')}`);
} else {
  initAnalytics(config.analytics.measurementId);
}

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <Root missingConfig={MISSING_CONFIG} />
  </React.StrictMode>
);
